<script>
    import _ from 'lodash';
    import {PATH_PREFIX} from '../../apiUrls.js';

    import Modal from '../Modal.svelte';
    import Button from '../Button.svelte';
    import {array, object, string} from 'yup';
    import {validateForm} from '../Form/utils.js';
    import Errors from '../Errors.svelte';
    import {get, submit} from '../../utils.js';
    import {sgettext} from '../../i18n.js';
    export let id = 'searchEmailGroupForm';
    export let emailGroupId = null;
    
    let title = sgettext('$$EDIT_MWC_EMAIL_CONFIG$$');
    let originalEmails = null; // to keep a copy of the original list
    let emails = null;
    let emailGroup = null;
    let emailsToAdd = "";
    
    let schema = object().shape({
      user_email: array().of(string().email().required()),
    });

    let formErrors = [];
  

  $: emailGroupUrl = `${PATH_PREFIX}/sw/old/administration/email-group-users/${emailGroupId}/`;

    async function getUsersOfEmailGroup() {
        if (emailGroupId) {
            const response = await get(emailGroupUrl);
            if (response.ok) {
                const res = await response.json();
                originalEmails = res.emails;
                emails = res.emails;
                emailGroup = res;
            } else {
                const error = await response.json();
                if (error.hasOwnProperty('error')) {
                    formErrors = error;
                }
            } 
        } else {
            formErrors = sgettext('$$SOMETHING_WENT_WRONG_FETCHING_USERS$$');
        }
    }
    async function handleRemove(emailToRemove) {
        emails = emails.filter(email => email != emailToRemove);
    }
    function cancelModal() {
        jQuery(`#${id}`).modal('hide');
        emailsToAdd = "";
        emails = originalEmails;
        formErrors = "";
    }

    async function handleAdd() {
        try {
            let emailList = emailsToAdd.toLowerCase().split(";").map(email => email.trim())
            await validateForm(schema, {user_email: emailList});

            for (let emailToAdd of emailList) {
                if (emailToAdd.split("@")[1].toLowerCase() !== "bhp.com") {
                    formErrors = sgettext("$$VALID_EMAIL_ADDRESSES_END_BHPCOM$$")
                    continue;
                } else if (emails.includes(emailToAdd)) {
                    if (emailList.length == 1) emailsToAdd = "";
                    continue;
                } else {
                    formErrors = "";
                    emails = [...emails, emailToAdd];
                    emailsToAdd = "";
                }
            }
        } 
        catch(err) {
            formErrors = sgettext('$$PLEASE_ENTER_VALID_EMAIL_ADDRESS$$');        
        }
    }

    async function handleSaveChanges() {  
        try {
            const originalEmailsSet = new Set(originalEmails);
            const emailsSet = new Set(emails);

            if (_.isEqual(originalEmailsSet, emailsSet)) {
                cancelModal();
            }
            else {
                const response = await submit(emailGroupUrl, "PUT", {
                    emails: emails,
                });
        
                if (response.ok) {
                    const res = await response.json();
                    cancelModal();
                    location.reload();
                }
                else {
                    const err = await response.json();
                    if (err.hasOwnProperty('error')) {
                        formErrors = err.error;
                    }
                }
            }
        }
        catch(err) {
            formErrors = sgettext('$$SOMETHING_WENT_WRONG_UPDATING_EMAIL$$');
        }
        finally {
            emailsToAdd = null;
        } 
    }

    $: if (emailGroupId) {
        getUsersOfEmailGroup();
    }
</script>

<Modal {id} {title} large={true} backdrop={'static'} onCancel={cancelModal}>
  <div slot="body">
    {#if formErrors && formErrors.length > 0}
      <Errors errors={formErrors} />
    {/if}
    {#if emailGroup}
      <h6 class="text-primary mb-4 mt-2">
        {emailGroup.plant.name}
        {emailGroup.plant.description
          ? ' - ' + emailGroup.plant.description
          : ''} | {emailGroup.work_centre.name}
        {emailGroup.work_centre.description
          ? ' - ' + emailGroup.work_centre.description
          : ''}
      </h6>
    {/if}
    <form on:submit|preventDefault={handleAdd}>
      <div class="form-group">
        <label for="addUserEmails">
          {sgettext('$$ADD_EMAIL_RECIPIENTS$$')}
          <i
            class="fa fa-info-circle text-secondary"
            data-toggle="tooltip"
            title={sgettext(
              '$$SEPARATE_MULTIPLE_EMAILS_USER1NAME$$'
            )}
          />
        </label>
        <div class="d-flex justify-content-between">
          <input
            id="addUserEmails"
            class="form-control mr-2"
            type="email"
            bind:value={emailsToAdd}
          />
          <button
            class="btn btn-primary ml-2"
            style="white-space: nowrap;"
            on:click|preventDefault={handleAdd}
            disabled={emailsToAdd?.length == 0}
          >
            {sgettext('$$ADD_1$$')}
          </button>
        </div>
      </div>
    </form>
    {#if emails && emails.length > 0}
      <hr />
      <p class="mb-1"><b>{emails.length} {sgettext('$$EMAIL_RECIPIENTS_1$$')}</b></p>
      <div class="emails-list">
        {#each emails as email}
          <div class="d-flex justify-content-between pl-2 pt-2 pr-3 email-row">
            <p>{email}</p>
            <p>
              <i
                class="fa fa-trash text-primary"
                on:click={() => handleRemove(email)}
              />
            </p>
          </div>
        {/each}
      </div>
    {/if}
  </div>

  <div slot="footer">
    <Button name={sgettext('$$CANCEL$$')} on:click={cancelModal} type="secondary" />
    <Button
      name={sgettext('$$SAVE_CHANGES_1$$')}
      on:click={handleSaveChanges}
      disabled={emailsToAdd && emailsToAdd.length == 0}
    />
  </div>
</Modal>

<style>
  .emails-list {
    max-height: 315px;
    overflow-y: scroll;
    background-color: #fff;
    border-radius: 5px;
    padding: 5px;
    border: 1px solid #ddd;
  }

  .email-row:hover {
    background-color: #eee;
    border-radius: 3px;
  }
</style>
